import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import InfiniteCarousel from 'react-leaf-carousel';
import styles from './styles/components/category-slider.scss';
import URLSanitizer from '../services/url-sanitizer';

class CategorySlider extends Component {
    render() {
        const storesInZone = this.props.storesGrouped
        && this.props.storesGrouped.data
        && this.props.storesGrouped.data[this.props.currentZone]
            ? this.props.storesGrouped.data[this.props.currentZone] : [];

        if (storesInZone.length === 0) {
            return null;
        }

        return (
            <div className="container">
                <h4
                    className={`text-center ${styles.title}`}
                >
                    <FormattedMessage id="zone-store" defaultMessage="Stores in zone" />
                </h4>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="mb-4">
                            <InfiniteCarousel
                                className={styles.categorySlider}
                                prevArrow={(
                                    <button
                                        className="InfiniteCarouselArrow InfiniteCarouselArrowPrev"
                                        type="button"
                                        style={{ left: '0 !important' }}
                                    >
                                        <i
                                            className={`${styles.arrowIcon} InfiniteCarouselArrowIcon InfiniteCarouselArrowPrevIcon`}
                                        />
                                    </button>
                                )}
                                nextArrow={(
                                    <button
                                        className="InfiniteCarouselArrow InfiniteCarouselArrowNext"
                                        type="button"
                                        style={{ right: '0 !important' }}
                                    >
                                        <i
                                            className={`${styles.arrowIcon} InfiniteCarouselArrowIcon InfiniteCarouselArrowNextIcon`}
                                        />
                                    </button>
                                )}
                                breakpoints={[
                                    {
                                        breakpoint: 500,
                                        settings: {
                                            slidesToShow: 1,
                                            slidesToScroll: 1,
                                        },
                                    },
                                    {
                                        breakpoint: 768,
                                        settings: {
                                            slidesToShow: 2,
                                            slidesToScroll: 2,
                                        },
                                    },
                                    {
                                        breakpoint: 992,
                                        settings: {
                                            slidesToShow: 3,
                                            slidesToScroll: 3,
                                        },
                                    },
                                    {
                                        breakpoint: 1200,
                                        settings: {
                                            slidesToShow: 4,
                                            slidesToScroll: 4,
                                        },
                                    },
                                ]}
                                dots={false}
                                showSides
                                sidesOpacity={0}
                                sideSize={0.5}
                                slidesToScroll={4}
                                slidesToShow={6}
                                scrollOnDevice
                                adaptiveHeight
                            >
                                {storesInZone.map((store) => (
                                    <div
                                        className={styles.slide}
                                        key={store.id}
                                        style={store.id === this.props.currentStore.id ? {

                                            borderBottom: 'solid',
                                            borderColor: '#d3af71',
                                        } : { }}
                                    >
                                        <Link to={`/${store.code}`}>
                                            <div className={styles.backgroundSlider}>
                                                {store.logo_file_name
                                                    ? (
                                                        <img
                                                            className={styles.imageSlider}
                                                            alt={store.name}
                                                            src={URLSanitizer.makeAbsolute(store.logo_file_name)}
                                                        />
                                                    )
                                                    : null}
                                                <div className={styles.contentOverlay} />
                                                <div className={`${styles.contentDetails} ${styles.fadeInBottom}`}>
                                                    <h4>{store.name}</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </InfiniteCarousel>
                        </div>
                    </div>
                </div>
                {/* <div className="row"> */}
                {/*    <div className="col-lg-12"> */}
                {/*        <div className="text-center" style={{ marginTop: 20 }}> */}
                {/*            <Link to="/stores"> */}
                {/*                <span */}
                {/*                    style={{ borderRadius: 20 }} */}
                {/*                    className={styles.showAll} */}
                {/*                > */}
                {/*                    <FormattedMessage id="show-all" defaultMessage="Show all" /> */}
                {/*                </span> */}
                {/*            </Link> */}
                {/*        </div> */}
                {/*    </div> */}
                {/* </div> */}
            </div>
        );
    }
}

export default CategorySlider;



/** WEBPACK FOOTER **
 ** ./src/components/category-slider.jsx
 **/